import React from 'react';

function WhyUs() {
  return (
    <section id="why-us" className="section why-us-section">
      <div className="container">
        <h2>Was ist Plottdesign?</h2>
        <p>
        Plottdesign ist eine vielseitige Technik, bei der präzise geschnittene Vinylfolien auf Textilien, Glas, Holz und andere Materialien übertragen werden – ganz ohne Tinte oder Trockenzeit.
        </p>
      </div>
    </section>
  );
}

export default WhyUs;